import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link to="/" className="logo-container">
      <img
        src="/images/logo.gif"
        alt="My Ultimate Game Challenge"
        title="My Ultimate Game Challenge"
      />
    </Link>
  );
};

export default Logo;
